import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import api from "../utils/axios/api";

interface CartContextType {
    nOrders: number
    changeNOrders: (n: number) => void
}

export const CartContext = createContext<CartContextType | undefined>(undefined)

interface CartProviderProps {
    children: ReactNode
}

interface Cart {
    id: string;
    amount: number;
}

export function CartProvider({ children }: CartProviderProps) {
    const [nOrders, setNOrders] = useState<number>(0)

    useEffect(() => {
        async function getOrders() {
            try {
                const clientId = localStorage.getItem('clientId');
                if (!clientId) return
                const response = await api.get<Cart[]>(`/cart/client/${clientId}`);

                changeNOrders(response.data.length)
            } catch (error) {

            }
        }

        getOrders()
    }, [])

    function changeNOrders(n: number) {
        setNOrders(n)
    }

    return (
        <CartContext.Provider value={{ changeNOrders, nOrders }}>
            {children}
        </ CartContext.Provider>
    )
}

export function useCart(){
    const context = useContext(CartContext)
    if (!context) {
        throw new Error('Header deve estar dentro do CartProvider');
    }
    return context
}
